(() => {
  const script = document.querySelector('[data-rail-stock-script]');
  const preview = script?.dataset.previewTheme;
  const pending = new WeakSet(), cache = new Map(), queue = [];
  let active = 0;
  const getURL = card => {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/products\/[^/]+/.test(url.pathname)) return null;
    url.search = ''; url.hash = '';
    url.searchParams.set('section_id','gearonimo-rail-stock-status');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  };
  const pump = () => {
    while (active < 4 && queue.length) {
      const job = queue.shift(); active++;
      job().finally(() => { active--; pump(); });
    }
  };
  const status = url => {
    if (!cache.has(url.href)) {
      cache.set(url.href, new Promise(resolve => {
        queue.push(async () => {
          const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 8000);
          try {
            const response = await fetch(url.href, {signal:controller.signal, credentials:'same-origin'});
            if (!response.ok) throw new Error('Stock status unavailable');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const node = doc.querySelector('[data-rail-stock-handle]');
            const handle = decodeURIComponent(url.pathname.split('/products/')[1]);
            resolve(node?.dataset.railStockHandle === handle ? node.dataset.railStockOne === 'true' : null);
          } catch { resolve(null); }
          finally { clearTimeout(timeout); }
        });
      }));
      pump();
    }
    return cache.get(url.href);
  };
  const check = async card => {
    const url = getURL(card);
    if (!url) return;
    const one = await status(url);
    if (!card.isConnected || getURL(card)?.href !== url.href || one === null) return;
    card.dataset.stockChecked = 'true';
    if (!one || card.querySelector('.product-card__scarcity')) return;
    const body = card.querySelector('.product-card__body');
    if (!body) return;
    const label = document.createElement('p');
    label.className = 'product-card__scarcity';
    label.textContent = 'Only one available';
    const title = body.querySelector('.product-card__title');
    if (title) title.after(label); else body.append(label);
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      check(entry.target);
    });
  }, {rootMargin:'300px'});
  const scan = root => {
    const cards = [...(root.matches?.('.product-card') ? [root] : []), ...root.querySelectorAll('.product-card')];
    cards.forEach(card => {
      if (card.dataset.stockChecked === 'true' || pending.has(card)) return;
      pending.add(card);
      if (card.querySelector('.product-card__scarcity')) {card.dataset.stockChecked='true';return;}
      observer.observe(card);
    });
  };
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.body,{childList:true,subtree:true});
})();
